module.exports = __webpack_public_path__ + "assets/images/project/people/womansenior-chart.png?v=f4596ac4";